import React, { useState } from "react"
import { useQuery } from "@tanstack/react-query"
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap"
import {
  getPolicies
} from "services/policyDirectoryServices"
import { CustomTable } from "./PolicyDirectory-management"
import useDebounce from "hooks/useDebounce"
import SearchBox from "components/Common/SearchBox"
import Pagination from "components/Common/Pagination"
import { StyledContainer } from "pages/Labels/Systems"
import LoadingSpinner from "components/Common/Loading-Spinner"
import ExportTable from "../../components/Common/ExportTable";
import { exportTableData } from "services/common"
import { Link } from "react-router-dom/cjs/react-router-dom.min"
import PolicyDirectoryFilters from "./PolicyDirectoryFilters"
import { areObjectsEqual } from "helpers/utlities"

const Policies = ({alert}) => {
  document.title = "Policy Directory"

  //pagination
  const [offset, setOffset] = useState(0)
  const [currentPage, setCurrentPage] = useState(1)
  const [totalEntries, setTotalEntries] = useState(0)
  const handlePageChange = pageNum => {
    const offsetVal = pageNum * 50 - 50
    setOffset(offsetVal)
    setCurrentPage(pageNum)
  }
  //search
  const [searchTerm, setSearchTerm] = useState("")
  const debouncedSearchTerm = useDebounce(searchTerm)

  const handleSearchInputChange = evt => {
    setSearchTerm(evt.target.value)
    setOffset(0)
    setCurrentPage(1)
  }

  //filters
  const initialFiltersState = {
    locations: [],
    systems: [],
    stages: [],
    categories: [],
    policyTypes: [],
    isOffTrack: null,
    isPolicyWin: null,
    isComplete: null,
    isDelayed: null,
    AGRASupported: null,
  }
  
  const [appliedFilters, setAppliedFilters] = useState(initialFiltersState);

  const applyFilters = (filters) => {
    setAppliedFilters(filters);
    setCurrentPage(1);
    setOffset(0);
    toggleModalFilter();
  }

  const areAnyFiltersSelected = () => !areObjectsEqual(appliedFilters, initialFiltersState);

  const clearFilters = () => {
    setAppliedFilters(initialFiltersState);
    setCurrentPage(1);
    setOffset(0);
  }

  const [modalFilter, setModalFilter] = useState(false)
  const toggleModalFilter = () => setModalFilter(prevState => !prevState)

  const {
    data: policyData = { policies: [] },
    isLoading,
  } = useQuery({
    queryKey: [
      "Policies",
      {
        debouncedSearchTerm,
        appliedFilters,
        page: currentPage,
      },
    ],
    queryFn: async() => {
      const { data, count } = await getPolicies({ searchTerm: debouncedSearchTerm, limit: 50, offset, ...appliedFilters });
      setTotalEntries(count);
      return data;
    }
  });

  const exportTable = async (type) => {
    try{ 
      const query = {
        export_format: type,
        // ...(selectedUser && { user_id: selectedUser }),
        // ...(selectedActivity && { activity: selectedActivity }),
      };

      exportTableData(query, "Policies");
    } catch(err){
      console.error(err);
      alert("Data export", false)
    }
  }

  return (
    <div>
      <div className="d-flex justify-content-between">
        <StyledContainer>
          <SearchBox searchChange={handleSearchInputChange} />
          <Button
            className="common-button"
            onClick={toggleModalFilter}
          >
            <i className="mdi mdi-filter-variant me-1" /> Filters
          </Button>
          {areAnyFiltersSelected() && (
            <Button
              className="d-flex align-items-center"
              style={{
                backgroundColor: "#f8f9fa",
                color: "black",
                margin: "15px 10px",
                border: "none",
                fontSize: "14px",
              }}
              onClick={clearFilters}
            >
              <i className="ph-x me-1"></i>
              Clear All Filters
            </Button>
          )}
        </StyledContainer>
        <Link to='/create-policy'>
          <button className="common-button">Create Policy</button>
        </Link>
        <ExportTable loadFilteredData={exportTable}></ExportTable>
        <Modal
          isOpen={modalFilter}
          toggle={toggleModalFilter}
          className="modal-lg"
        >
          <ModalHeader toggle={toggleModalFilter}>
            <i className="mdi mdi-filter-variant me-1"></i>
            Filters
          </ModalHeader>
          <ModalBody>
            <PolicyDirectoryFilters
              appliedFilters={appliedFilters}
              applyFilters={applyFilters}
            />
          </ModalBody>
        </Modal>
      </div>
      {isLoading ? <LoadingSpinner /> :
        Array.isArray(policyData) && policyData.length > 0 ? (
        <>
          <CustomTable
            data={policyData || []}
            alert={alert}
          />
          <Pagination
            currentPage={currentPage}
            goToPage={handlePageChange}
            totalEntries={totalEntries}
          />
        </>
        ) : 
        Array.isArray(policyData) && policyData.length === 0 ? 
          <div style={{ textAlign: 'center', marginTop: '20px' }}>
            <p>No policies available.</p>
          </div> 
        : null
      }
    </div>
  )
}

export default Policies;